import React from 'react'

import { Breadcrumbs } from '@/components/layout/Breadcrumbs/Breadcrumbs'
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs'

// import { NotificationDropdown } from './NotificationDropdown'
import { UserMenuDropdown } from './UserMenuDropdown'

export const Header: React.FC = () => {
  const { breadcrumbs, pageTitle } = useBreadcrumbs()

  const breadcrumbItems = breadcrumbs.map((item) => ({
    label: item.label,
    href: item.href || undefined
  }))

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-200 h-14">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 lg:pl-0 pl-12">
          <div className="flex items-center flex-1 min-w-0">
            <div className="flex-1 min-w-0">
              <Breadcrumbs items={breadcrumbItems} />
            </div>
          </div>

          <div className="flex items-center justify-center flex-1">
            {pageTitle && (
              <h1 className="text-lg font-semibold text-gray-900 truncate">{pageTitle}</h1>
            )}
          </div>

          <div className="flex items-center space-x-2 flex-1 justify-end">
            {/* <NotificationDropdown /> */}
            <UserMenuDropdown />
          </div>
        </div>
      </div>
    </header>
  )
}
